import { FormValidation } from "@lib/types/form";
import { Validator } from "../Validator";

const verifyCigValidators = {
  cigId: (validation: FormValidation, value: any) => {
    new Validator(validation, value).exists().is("string");
  },
  verificationCode: (validation: FormValidation, value: any) => {
    new Validator(validation, value).exists().is("string").length.equalTo(8);
  },
};

export default verifyCigValidators;
